import { createSlice} from "@reduxjs/toolkit";
import { actions } from "react-table";

const initialState = {
    todoActiveButton: {
        name: "OrderTable"
    },
    ordersToDo: [],
    todoOrderDetails: {},
    serialNumberResponse: {},
    saveBillReferenceResponse: {},
    orderQrResponse: {},
    billReferences: "",
    resetResponseApi: {}
}

const TodoSlice = createSlice({
    name: "todo",
    initialState,
    reducers: {
        setTodoActiveButton: (state, action) => {
            state.todoActiveButton = action.payload
        },
        setTodoOrderDetails: (state, action) => {
            state.todoOrderDetails = action.payload
        },
        setOrdersToDo: (state, action) => {
            state.ordersToDo = action.payload
        },
        setSerialNumberResponse: (state, action) => {
            const { data, status } = action.payload;
            state.serialNumberResponse = { data, status };
        },
        setSaveBillReferenceResponse: (state, action) => {
            const { data, status } = action.payload;
            state.saveBillReferenceResponse = { data, status };
        },
        setOrderQrResponse: (state, action) => {
            const { data, status } = action.payload;
            state.orderQrResponse = { data, status };
        },
        setBillReferences: (state, action) => {
            state.billReferences = action.payload; 
          },
        setResetResponseApi: (state, action) => {
        state.resetResponseApi = action.payload; 
        },  
          resetResponse: (state) => {
            state.serialNumberResponse = {};
            state.saveBillReferenceResponse = {};  
            state.orderQrResponse = {};  
            state.billReferences = "";
            state.resetResponseApi = {}


          },
          
    }
})


export const { setTodoActiveButton, setTodoOrderDetails, setSerialNumberResponse, setSaveBillReferenceResponse, setOrderQrResponse, setBillReferences, setOrdersToDo, setResetResponseApi, resetResponse } = TodoSlice.actions;
export default TodoSlice.reducer;